import React, { useEffect, useState, useContext, Fragment } from 'react';
import { isNumeric, isMonthAndYearEmpty, getStatusFlagValue, getButtonDisabledStates } from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading';


const WholeSaleKanpurDistrictData = ({
  WholeSaleKanpurItems,
  monthName,
  yearName,
  config,
  resetMothAndYearField,
  payload,
  userInfoObject,
  dateName,
  districtCode,
  storedLanguage,
  othersData,
  titlesData
}) => {

  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
  const [isAnyRejectChecked, setIsAnyRejectChecked] = useState(false); 
  
  let srNo = 0;
  let isDisable = false;
  let sonf=0;
  let almonds=0;
  let raw_jute=0;
  let districtAndDivision = false;
  const static_items_code_1=["323", "315", "322", "361","350","402","354","380"]
  const static_items_code_2=["016", "316", "016", "353","413","369","360","319",
      "343", "330", "071", "074","033","386"]
  const static_items_code_3= ["115","387","340","326","312"]
  const static_items_code_4=["370", "331"]
 const static_items_code_5=["324","358","113","372",
    "105", "373", "382", "076"]
    let headQuarterRemark=[
      'Price is Too Low.',
      'Price is too High.',
      'Price does not match with unit.',
      'Price does not match with variety.'
      ]
      let otherRemark=[
      'Production is low',
      'Production is high',
      'Less supply',
      'High supply',
      'Not Available.',
      'On sale.',
      'Seasonal effect',
      'Discounted Item',
      'Other.'
       ]
  



  const {
    isSaveBtnDisable,
    isAcceptBtnDisable,
    isSubmitBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);

  useEffect(() => {
    const initialData = {};
    WholeSaleKanpurItems.forEach(item => {
      initialData[item.itemCode] = {

        price: item.price,
        itemCode: item.itemCode,
        itemName: item.itemName,
        statusFlag: item.statusFlag,
        itemUnitName: item.itemUnitName,
        itemVarietyName: item.itemVarietyName,
        comments: item.comments || '',
        // remark: "No",
        // remark_text: "demo_reamrk_text",

        style: {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 3px'
        },
        isRequiredRemark: false,
        isRejectStatus: item.statusFlag === '6'

      };

    });
    setItemData(initialData);
  }, [WholeSaleKanpurItems]);





  // Table Header
  const renderHeader = (i) => (
    <thead key={`thead-${i}`}>
      <tr>
        <th>{storedLanguage === 'hi' ? othersData.hi.SERIAL_NO : othersData.en.SERIAL_NO}</th>
        <th>{storedLanguage === 'hi' ? othersData.hi.ITEM_NAME : othersData.en.ITEM_NAME}</th>
        <th>{storedLanguage === 'hi' ? othersData.hi.VARITRY_NAME : othersData.en.VARITRY_NAME}</th>
        <th>{storedLanguage === 'hi' ? titlesData.hi.UNIT : titlesData.en.UNIT}</th>
        <th>{storedLanguage === 'hi' ? othersData.hi.CURRENT_PRICE : othersData.en.CURRENT_PRICE}</th>
        <th>{storedLanguage === 'hi' ? othersData.hi.REMARKS : othersData.en.REMARKS}</th>
        <th>{storedLanguage === 'hi' ? othersData.hi.REJECT_STATUS : othersData.en.REJECT_STATUS}</th>
      </tr>
    </thead>
  );

  //Handle validate Item Price
  const validateItemVariationPrice = (itemCode, field, newValue, average, variation) => {

    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }

    let dynamicStylesForTextBox = {}
    let isRequiredRemark = false

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        newValue = dynamicStylesForTextBox
        if (itemData[itemCode].comments === 'No' || itemData[itemCode].comments === '') {
          isRequiredRemark = true
        }

      } else {

        dynamicStylesForTextBox = {
          borderColor: '#dcdfe1',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        isRequiredRemark = false
        newValue = dynamicStylesForTextBox


      }
    }
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
        'isRequiredRemark': isRequiredRemark
      }
    }));

  }
  //handle reject check box checked




  //Handle Price On change   
  const handlePriceChange = (itemCode, field, newValue) => {
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
   

    let isRequiredRemark = false;

    if (field === 'price' && !isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    if (field === 'comments' && itemData[itemCode].isRequiredRemark === false 
      && (newValue === '' && itemData[itemCode].comments === '')) {
      isRequiredRemark = true;
    }


    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [itemCode]: {
          ...prevItemData[itemCode],
          [field]: newValue,
          'isRequiredRemark': isRequiredRemark
        }
      };

      return updatedItemData;
    });
  };




  //handle reject check box checked
  const handleCheckboxChange = (itemCode, field, newValue) => {
    
    let isRequiredRemark = (itemData[itemCode]?.comments ? false : true); //required validation for Remarks
    setItemData(prevItemData => ({
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: !prevItemData[itemCode][field],
        'isRequiredRemark': isRequiredRemark
      }
    }));
  };

  const checkBoxcheckedLength = () => {
    const filteredData = Object.fromEntries(
      Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
    );
    return Object.keys(filteredData).length
  }

  // Handle Reset formData
  const resetFormData = () => {
    setItemData({});
    resetMothAndYearField();
  };



  //handle Save and update data
  const handleSaveHapurMandiFormDatas = async (e, buttonType) => {
    const customItemCodes = [];
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }
    if (!dateName) {
      toast.error("Please select date.", messages.COLOR_RED);
      return;
    }
    if (!districtCode) {
      toast.error("Please select district.", messages.COLOR_RED);
      return;
    }

    let allData = itemData;
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag
    let check = 0;
    let statusFlag = '';

   

    // Flag to check if any remarks field is required but not filled
    // let remarksRequiredNotFilled = false;

    for (let itemCode in allData) {
      let price = allData[itemCode].price;
      let comment = allData[itemCode].comments;

      let source = 1;
      let isRequiredRemark = allData[itemCode].isRequiredRemark;
      let isRejectStatus = allData[itemCode].isRejectStatus;
      
      statusFlag = (itemData[itemCode].statusFlag === '') ?
        clickButtonStatusFlag
        :
        itemData[itemCode].statusFlag //data base Statusflag

      if (buttonType === "REJECT" && isRejectStatus) {
        check++;
        if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "SAVE" ) {
         if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "ACCEPT" || buttonType === "SAVE") { //Accept Button click
        statusFlag = clickButtonStatusFlag
      }

      if (buttonType === "SUBMIT") { //Submit Button click
        if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        statusFlag = clickButtonStatusFlag;
      }

      if ((price === '' || price === null)) {
        price = "0.00";
      }

      if (isRequiredRemark && comment === 'NA') {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (comment === '' || comment == null) {
        comment = 'NA';
      }

      const customObject = {
        source: source.toString(),
        priceMonth: monthName >= 10 ? monthName.toString() : `0${monthName}`,
        priceYear: yearName.toString(),
        itemCode: itemCode.toString(),
        price: price.toString(),
        statusFlag: statusFlag.toString(),
        comments: comment.toString(),
        priceDate: dateName.toString()
      };

      customItemCodes.push(customObject);
    }

    

    if (buttonType === "REJECT" && check === 0) {
      toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
      return false;
    }



    let postData = {
      itemCodes: customItemCodes,
      payload: {
        dateName: dateName.toString(),
        districtCode: districtCode.toString(),
        monthName: monthName >= 10 ? monthName.toString() : `0${monthName}`,

        yearName: yearName.toString(),
        buttonType: buttonType.toString()
        // statusButtonFlag: clickButtonStatusFlag
      }
    }

    showLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/otherPrices/saleKanpurDistrictSave`, postData, config);
      if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    }
    finally {
      showLoading(false);
      resetFormData()
    }
  }




  const getRemarkDropDown =(userInfoObject)=>{
    let html=''

    if(userInfoObject.userLevel==="HEAD QUARTER"){

        html= headQuarterRemark.map((remarkItem,i)=>{
          return (
          <option value={remarkItem} key={i}>{remarkItem}</option>

        )})

    }else{
        html= otherRemark.map((remarkItem,i)=>{
            return (
            <option value={remarkItem} key={i}>{remarkItem}</option>

          )})
    }

        return html;
   }

 
  
  const generateRomanSuffix = (index) => {
    const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']; // Add more as needed
    return romanNumerals[index];
  };

  // Group items by itemName
  
  const groupItemsByName = (items) => {
    const grouped = {};
    items.forEach((item, index) => {
      if (!grouped[item.itemName]) {
        grouped[item.itemName] = [];
      }
      grouped[item.itemName].push({ ...item, index });
    });
    return grouped;
  };

  const groupedItems = groupItemsByName(WholeSaleKanpurItems);


  return (
    <>
      {/* <ToastContainer /> */}
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered">
            {renderHeader(0)}
           

            <tbody>
   { WholeSaleKanpurItems.map((item,index)=>{
     
     srNo=index
      let mergeColumn=0;
      let romanDigit='';
        if (checkBoxcheckedLength() > 0) {
          isDisable = false
        } else if (payload.statusFlagSet === "6") {
          if (isAcceptBtnDisable && checkBoxcheckedLength() !== 0) {
            isDisable = true
          }

        } else if (isAcceptBtnDisable) {

          isDisable = false
        }

      if (item.itemName.trim() ==='Sonf' || item.itemName.trim() ==='Almonds' 
      || item.itemName.trim() ==='Raw jute' ){
       

              //  Item for Sonf condition
                  if(item.itemCodes==='389'){
                      sonf++;
                      if(sonf===1){
                      srNo++;
                      romanDigit=`-I`
                    }else{
                      romanDigit=`-II`
                      }
                }

                  //  Item for Almonds condition
                  if(item.itemCodes==='309'){
                    almonds++;
                    if(almonds===1){
                    srNo=srNo-2;
                    romanDigit=`-I`
                  }else{
                    romanDigit=`-II`
                    srNo=srNo-3;
                    }
               }

              //  Item for Raw Jute condition
              if(item.itemCodes==='374'){
                raw_jute++;
                if(raw_jute===1){
                srNo =srNo-4;
                romanDigit=`-I`
              }else{
                romanDigit=`-II`
                srNo =srNo-5;
                }
            }
            mergeColumn++;


      }else{

        // form serial no***************
            if(sonf !== 2){
              srNo++;
            }

            if(item.itemCodes==='397'){
                romanDigit=`-I`
                srNo=index
              } else if(item.itemCodes==='433'){
                romanDigit=`-II`
                srNo=index-1
            }else if(item.itemCodes==='432'){
              romanDigit=`-III`
              srNo=index-2
            }else if(item.itemCodes==='384'){//Sesame oil
              romanDigit=`-I`
              srNo=index-3
            } else if(item.itemCodes==='351'){//Mahua oil
              romanDigit=`-II`
              srNo=index-4
            }else if(static_items_code_1.includes(item.itemCodes)){
                srNo=srNo-2;
            }else if(static_items_code_2.includes(item.itemCodes)){
              srNo=srNo-3;
            }else if(static_items_code_3.includes(item.itemCodes)){
              srNo=srNo-4;
            } else if(static_items_code_4.includes(item.itemCodes)){
              srNo=srNo-5;
            }else if(item.itemName.trim()==='Table cloth mafola  unwashed'){
              srNo=srNo-5;
              romanDigit=`-I`
            }else if(item.itemName.trim()==='Table cloth mafola washed'){
              srNo=srNo-6;
              romanDigit=`-II`
            }else if(static_items_code_5.includes(item.itemCodes)){
              srNo=srNo-6;
            }else if(item.itemCodes==='406'){
              srNo=srNo-6;
              romanDigit=`-I`
            } else if(item.itemCodes==='332'){
              srNo=srNo-7;
              romanDigit=`-II`
            
            }

      }

      if ((userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL')) {
        districtAndDivision = true;
      }


       return <>
                {
                  (item.itemName.trim() !== 'Sonf' &&  item.itemName.trim() !=='Almonds' 
                    && item.itemName.trim() !=='Raw jute' ) && 

                    <tr key={`tbody_1${index}`}>
                     <td><b>{srNo}{romanDigit}</b></td>
                      <td>{item.itemName}</td>
                      <td>{item.itemVarietyName}</td>
                      <td>{item.itemUnitName}</td>
                      <td>
                      <input
                          type="text"
                          style={itemData[item.itemCode]?.style || {}}
                          key={index}
                          className="form-control"
                          maxLength="15"
                          name={`price${[item.itemCode]}`}
                          id={`price${item.itemCode}`}
                          value={itemData[item.itemCode]?.price || ''}
                          onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
                          onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, 10)}
                        />
                      </td>
                      <td>


                          {
                          userInfoObject.userLevel === "HEAD QUARTER" ?
                          item.comments !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
                          otherRemark.includes(itemData[item.itemCode]?.comments) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
                          
                          :
                          item.comments !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.comments) &&
                          headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
                            <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
							
					                 }

                            <select
                              // disabled={isItemCodeInArray ? 'disabled' : ''}
                              name={`remark_${index}`}
                              id={`remark${index}`}
                              className="form-select"
                              value={itemData[item.itemCode]?.comments || ''}
                              onChange={e => handlePriceChange(item.itemCode, 'comments', e.target.value)}
                            >
                              <option value="">[---Select---]</option>

                              {getRemarkDropDown(userInfoObject)}
                              </select>

                            {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                              (
                                <div style={{ color: 'red', marginTop: '10px' }} key={index}>
                                  Please Select the Remark
                                </div>
                              )
                              :
                              ''
                            }

                     </td> 
                     <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                      <input
                        disabled={districtAndDivision ? 'disabled' : ''}
                        type="checkbox"
                        name={`status${index}`}
                        id={`status${index}`}
                        onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.checked)}
                        checked={itemData[item.itemCode]?.isRejectStatus || false}
                      />
                      </td>
                  </tr>
           
                }


          {/*********** * Sonf ******************/}

          {(item.itemName.trim() ==='Sonf') &&     
           
           <tr key={`tbody_2${index}`}>
           <td><b>{srNo}{romanDigit}</b></td>
            {
              (sonf !==2 )  && 
              <td rowSpan={((mergeColumn === 1 ?2:''))}>{item.itemName}</td> 
            }
           <td>{item.itemVarietyName}</td>
            <td>{item.itemUnitName}</td>
            <td>
            <input
              type="text"
              style={itemData[item.itemCode]?.style || {}}
              key={index}
              className="form-control"
              maxLength="15"
              name={`price${[item.itemCode]}`}
              id={`price${item.itemCode}`}
              value={itemData[item.itemCode]?.price || ''}
              onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
              onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, 10)}
            />
            </td>
            <td>
             {
              userInfoObject.userLevel === "HEAD QUARTER" ?
              item.comments !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
              otherRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
              
              :
              item.comments !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.comments) &&
              headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
  
                }

                <select
                  name={`remark_${index}`}
                  id={`remark${index}`}
                  className="form-select"
                  value={itemData[item.itemCode]?.comments || ''}
                  onChange={e => handlePriceChange(item.itemCode, 'comments', e.target.value)}
                >
                  <option value="">[---Select---]</option>

                  {getRemarkDropDown(userInfoObject)}
                  </select>

                {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                  (
                    <div style={{ color: 'red', marginTop: '10px' }} key={index}>
                      Please Select the Remark
                    </div>
                  )
                  :
                  ''
                            }

             </td> 
             <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
            <input
                disabled={districtAndDivision ? 'disabled' : ''}
                type="checkbox"
                name={`status${index}`}
                id={`status${index}`}
                onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.checked)}
                checked={itemData[item.itemCode]?.isRejectStatus || false}
              />
            </td>

            </tr>
           }


         {/*********** * Almonds ******************/}

          { ( item.itemName.trim() ==='Almonds') &&     
         
            <tr  key={`tbody_3${index}`}>
            <td><b>{srNo}{romanDigit}</b></td>
            {(almonds !==2 )  && 
              <td rowSpan={((mergeColumn === 1 ?2:''))}>{item.itemName}</td> 
             }
             <td>{item.itemVarietyName}</td>
            <td>{item.itemUnitName}</td>
            <td>
            <input
              type="text"
              style={itemData[item.itemCode]?.style || {}}
              key={index}
              className="form-control"
              maxLength="15"
              name={`price${[item.itemCode]}`}
              id={`price${item.itemCode}`}
              value={itemData[item.itemCode]?.price || ''}
              onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
              onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, 10)}
            />
            </td>
            <td>

             {
              userInfoObject.userLevel === "HEAD QUARTER" ?
              item.comments !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
              otherRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
              
              :
              item.comments !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.comments) &&
              headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
  
                }

                <select
                  // disabled={isItemCodeInArray ? 'disabled' : ''}
                  name={`remark_${index}`}
                  id={`remark${index}`}
                  className="form-select"
                  value={itemData[item.itemCode]?.comments || ''}
                  onChange={e => handlePriceChange(item.itemCode, 'comments', e.target.value)}
                >
                  <option value="">[---Select---]</option>

                  {getRemarkDropDown(userInfoObject)}
                  </select>

                {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                  (
                    <div style={{ color: 'red', marginTop: '10px' }} key={index}>
                      Please Select the Remark
                    </div>
                  )
                  :
                  ''
                }

          </td> 
            <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
            <input
              disabled={districtAndDivision ? 'disabled' : ''}
              type="checkbox"
              name={`status${index}`}
              id={`status${index}`}
              onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.checked)}
              checked={itemData[item.itemCode]?.isRejectStatus || false}
            />
            </td>

           </tr>
          }



          {/*********** * Raw jute ******************/}

          {(item.itemName.trim() ==='Raw jute') &&     
        
          <tr  key={`tbody_4${index}`}>
           <td><b>{srNo}{romanDigit}</b></td>
            {(raw_jute !==2 )  && 
              <td rowSpan={((mergeColumn === 1 ?2:''))}>{item.itemName}</td> 
            }
             <td>{item.itemVarietyName}</td>
            <td>{item.itemUnitName}</td>
            <td>
            <input
              type="text"
              style={itemData[item.itemCode]?.style || {}}
              key={index}
              className="form-control"
              maxLength="15"
              name={`price${[item.itemCode]}`}
              id={`price${item.itemCode}`}
              value={itemData[item.itemCode]?.price || ''}
              onChange={e => handlePriceChange(item.itemCode, 'price', e.target.value)}
              onBlur={e => validateItemVariationPrice(item.itemCode, 'style', parseFloat(e.target.value), item.average, 10)}
            />
            </td>
            <td>
             {
              userInfoObject.userLevel === "HEAD QUARTER" ?
              item.comments !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
              otherRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
              
              :
              item.comments !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.comments) &&
              headQuarterRemark.includes(itemData[item.itemCode]?.comments) &&
                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.comments}</label>
  
                }

                <select
                  // disabled={isItemCodeInArray ? 'disabled' : ''}
                  name={`remark_${index}`}
                  id={`remark${index}`}
                  className="form-select"
                  value={itemData[item.itemCode]?.comments || ''}
                  onChange={e => handlePriceChange(item.itemCode, 'comments', e.target.value)}
                >
                  <option value="">[---Select---]</option>

                  {getRemarkDropDown(userInfoObject)}
                  </select>

                {(itemData[item.itemCode]?.isRequiredRemark !== undefined && itemData[item.itemCode]?.isRequiredRemark) ?
                  (
                    <div style={{ color: 'red', marginTop: '10px' }} key={index}>
                      Please Select the Remark
                    </div>
                  )
                  :
                  ''
                }

             </td> 
             <td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
            <input
              disabled={districtAndDivision ? 'disabled' : ''}
              type="checkbox"
              name={`status${index}`}
              id={`status${index}`}
              onChange={(event) => handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.checked)}
              checked={itemData[item.itemCode]?.isRejectStatus || false}
            />
            </td>
           

           </tr>
          
          }


                  
        
    
    </>
   })}

            </tbody>


          </table>
        </div>

        <div className="row">
          <div className="col-12 text-center pt-3">

              <button
                onClick={(e) => handleSaveHapurMandiFormDatas(e, 'SAVE')}

                type="button"
                className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`}
              >
                Save
              </button>
              {(userInfoObject.userLevel === 'DISTRICT LEVEL' || userInfoObject.userLevel === 'DIVISION LEVEL') &&
                <button
                  onClick={(e) => handleSaveHapurMandiFormDatas(e, 'SUBMIT')}
  
                  type="button"
                  className={`btn btn_orange mx-1 ${isSubmitBtnDisable || checkBoxcheckedLength() > 0 ? 'disabled' : ''}`}
                >
                  Submit
                </button>
            }

            {
              (userInfoObject.userLevel === 'HEAD QUARTER') &&
              <>

                <button
                  onClick={(e) => handleSaveHapurMandiFormDatas(e, 'ACCEPT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${isAcceptBtnDisable ? 'disabled' : ''}`}
                >Accept
                </button>
                <button
                  onClick={(e) => handleSaveHapurMandiFormDatas(e, 'REJECT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                >Reject
                </button>
              </>

            }

            <button
              type="reset"
              className="btn btn_orange mx-1"
              onClick={resetFormData}
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn_orange mx-1"
              onClick={(e) => (navigate("/dashboard"))}
            >
              Cancel
            </button>
          </div>
        </div>

      </div>
    </>
  )
}

export default WholeSaleKanpurDistrictData